import { merge } from 'ramda';
import { SUCCESS, REQUEST, FAIL } from 'src/store/actions/machineTimesActions';

const initialState = {
  list: [],
  fetching: false,
  errors: []
};

const machineTimes = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST:
      return merge(state, { fetching: true });
    case SUCCESS:
      return merge(state, { list: action.machineTimes, fetching: false, errors: [] });
    case FAIL:
      return merge(state, { fetching: false, errors: [action.error] });
    default:
      return state;
  }
};

export default machineTimes;
